import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../App';

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1a1a2e',
    padding: '20px',
  },
  header: {
    color: '#e94560',
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '4px',
    marginTop: '20px',
  },
  subtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginBottom: '32px',
  },
  card: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '24px',
    marginBottom: '16px',
  },
  label: {
    color: '#a0a0b0',
    fontSize: '13px',
    marginBottom: '8px',
    display: 'block',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '16px',
    backgroundColor: '#0f3460',
    border: '1px solid #0f3460',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '16px',
    marginBottom: '20px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '18px',
    backgroundColor: '#e94560',
    border: 'none',
    borderRadius: '12px',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  backButton: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginBottom: '16px',
    cursor: 'pointer',
  },
  success: {
    color: '#00cc00',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  error: {
    color: '#e94560',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
};

function ChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  async function handleChange() {
    setError('');
    setSuccess('');
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
        }),
      });
      if (res.ok) {
        setSuccess('Password changed successfully');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => navigate('/select-dealer'), 2000);
      } else {
        const data = await res.json();
        setError(data.detail || 'Failed to change password');
      }
    } catch (e) {
      setError('Could not connect to server');
    }
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <div style={styles.backButton} onClick={() => navigate('/select-dealer')}>
        ← Back
      </div>
      <div style={styles.header}>Change Password</div>
      <div style={styles.subtitle}>Update your account password</div>
      <div style={styles.card}>
        {error && <div style={styles.error}>{error}</div>}
        {success && <div style={styles.success}>{success}</div>}
        <label style={styles.label}>Current Password</label>
        <input
          style={styles.input}
          type="password"
          value={currentPassword}
          onChange={e => setCurrentPassword(e.target.value)}
          placeholder="••••••••"
        />
        <label style={styles.label}>New Password</label>
        <input
          style={styles.input}
          type="password"
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)}
          placeholder="Minimum 8 characters"
        />
        <label style={styles.label}>Confirm New Password</label>
        <input
          style={styles.input}
          type="password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          placeholder="Re-enter new password"
        />
        <button style={styles.button} onClick={handleChange} disabled={loading}>
          {loading ? 'Updating...' : 'Update Password'}
        </button>
      </div>
    </div>
  );
}

export default ChangePassword;
